import type { AccountPersonaDisclosure } from '@confluent/shared/lib/account-persona/disclosure';
import { DisclosureBadge } from '../ui/DisclosureBadge.js';

/** Footer of an account persona's message: the badge plus the disclosure sentence. Always visible. */
export function DisclosureFooter({
  disclosure,
  personaName,
}: {
  disclosure: AccountPersonaDisclosure;
  personaName: string;
}) {
  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded-lg border bg-surface-alt px-3 py-1.5"
      aria-label={`${personaName}: ${disclosure.label}`}
    >
      <DisclosureBadge disclosure={disclosure} />
      <span className="text-xs text-muted">{disclosure.text}</span>
    </div>
  );
}
